import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

const DEVELOPER_ROLE_ID = "b2012b16-f7c1-4628-84e9-70319c6eb3ef";

export async function clearAllRoles(
  client: racehorse360.UserServiceSimpleClient,
  userId: string
): Promise<void> {
  const userRoles = await client.listUserRoles(
    racehorse360.ListUserRolesRequest.create({
      query: {
        userIds: [userId]
      },
      pagingOptions: {
        maxResults: 100
      },
      getOptions: {
        select: ["facility", "trainer", "role.name", "role.roleType"]
      }
    })
  );

  for (const userRole of userRoles.userRoles) {
    if (userRole.role.id !== DEVELOPER_ROLE_ID) {
      await client.removeRole(
        racehorse360.RemoveRoleRequest.create({
          id: userId,
          roleId: userRole.role.id,
          facilityId: userRole.facility?.id,
          trainerId: userRole.trainer?.id
        })
      );
    }
  }
}

export async function clearAllRoleRequests(
  client: racehorse360.UserServiceSimpleClient,
  userId: string
): Promise<void> {
  const userRoleRequests = await client.listUserRoleRequests(
    racehorse360.ListUserRoleRequestsRequest.create({
      query: {
        userIds: [userId],
        userRoleRequestStatuses: [
          racehorse360.UserRoleRequestStatus.USER_ROLE_REQUEST_STATUS_REQUESTED
        ]
      },
      pagingOptions: {
        maxResults: 100
      },
      getOptions: {
        select: [
          "user.firstName",
          "user.lastName",
          "user.email",
          "user.licenseNumber",
          "facility",
          "trainerName",
          "role.name",
          "role.roleType"
        ]
      }
    })
  );

  for (const request of userRoleRequests.userRoleRequests) {
    await client.deleteUserRoleRequest(
      racehorse360.DeleteUserRoleRequestRequest.create({
        id: request.id
      })
    );
  }
}

export async function clearAllRolesAndRequests(
  client: racehorse360.UserServiceSimpleClient,
  userId: string
): Promise<void> {
  await clearAllRoles(client, userId);
  await clearAllRoleRequests(client, userId);
}

export async function approveAllPendingRoles(
  client: racehorse360.UserServiceSimpleClient,
  userId: string,
  trainerId: string
): Promise<void> {
  const userRoleRequests = await client.listUserRoleRequests(
    racehorse360.ListUserRoleRequestsRequest.create({
      query: {
        userIds: [userId],
        userRoleRequestStatuses: [
          racehorse360.UserRoleRequestStatus.USER_ROLE_REQUEST_STATUS_REQUESTED
        ]
      },
      pagingOptions: {
        maxResults: 100
      },
      getOptions: {
        select: [
          "user.firstName",
          "user.lastName",
          "user.email",
          "user.licenseNumber",
          "facility",
          "trainerName",
          "role.name",
          "role.roleType"
        ]
      }
    })
  );

  for (const userRoleRequest of userRoleRequests.userRoleRequests) {
    await client.approveUserRoleRequest(
      racehorse360.ApproveUserRoleRequestRequest.create({
        id: userRoleRequest.id,
        trainerId
      })
    );
  }
}

export async function setDeveloperUserRole(
  client: racehorse360.UserServiceSimpleClient,
  userId: string,
  desiredRole: { id: string; facilityId?: string; trainerId?: string }
): Promise<void> {
  await clearAllRoles(client, userId);

  await client.assignRole(
    racehorse360.AssignRoleRequest.create({
      id: userId,
      roleId: desiredRole.id,
      facilityId: desiredRole.facilityId,
      trainerId: desiredRole.trainerId
    })
  );
}
